<script>
import {ref} from "vue";
import ActionButton from "@/components/ui/ActionButton.vue";

export default {
  name: "FileButton",
  components: {ActionButton},
  props: {
    accept: {type: String, default: "image/*"},
    caption: {type: String, default: "Выберите файл"},
    disabled: {type: Boolean, default: false},
  },
  emits: ['select'],
  setup(props, {emit}) {
    const input = ref(null);

    function openDialog() {
      input.value?.click();
    }

    function changeHandler(event) {
      const file = event.target.files?.[0] || null;
      emit('select', file);
      event.target.value = "";
    }

    return {input, openDialog, changeHandler};
  }
}
</script>

<template>
  <div class="fileButton">
    <input
        ref="input"
        class="fileButton__input"
        type="file"
        :accept="accept"
        :disabled="disabled"
        @change="changeHandler"
    />
    <ActionButton :disabled="disabled" @buttonClick="openDialog">
      <template #caption>{{ caption }}</template>
    </ActionButton>
  </div>
</template>

<style scoped lang="scss">
.fileButton {
  display: inline-flex;

  &__input {
    display: none;
  }
}
</style>
